/**
 * ModulePowerInput - Module wattage input field
 *
 * Numeric input for specifying module power rating in watts.
 */

import React from 'react';

interface ModulePowerInputProps {
  value: number;
  onChange: (watts: number) => void;
}

export function ModulePowerInput({ value, onChange }: ModulePowerInputProps) {
  return (
    <div>
      <label className="block font-semibold text-gray-700 mb-1">Module Power (W)</label>
      <input
        type="number"
        step="10"
        min="100"
        max="1000"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        className="w-full px-2 py-1 border border-gray-300 rounded text-xs"
        placeholder="Watts"
      />
    </div>
  );
}

export default ModulePowerInput;
